import React, { useState, useEffect, useMemo } from "react"
import axios from "axios"
import Modal from "@mui/material/Modal"
import Box from "@mui/material/Box"

import { Link, useNavigate, useLocation } from "react-router-dom"

import "./Incident.sass"
import { useAuth } from "../../contexts/AuthContext"

import TasksTable from "./TasksTable"

import { toast } from "react-toastify"

function Incident() {
  const [incidentData, setIncidentData] = useState({})
  const [tasksData, setTasksData] = useState([])
  const [dataLoadError, setDataLoadError] = useState(null)

  const incidentId = useLocation().pathname.split("/")[2]

  useEffect(() => {
    const token = localStorage.getItem("token") || 0

    const api = axios.create({
      baseURL: process.env.REACT_APP_API_URL,
      headers: {
        Authorization: token,
      },
    })

    api
      .get("incident/" + incidentId)
      .then((response) => {
        setIncidentData({
          ...response.data,
          statusnewid:
            response.data[
              "statecode@OData.Community.Display.V1.FormattedValue"
            ] == "Ativo"
              ? 1
              : response.data[
                  "statecode@OData.Community.Display.V1.FormattedValue"
                ] == "Resolvido"
              ? 2
              : 3,
          statusnewname:
            response.data[
              "statecode@OData.Community.Display.V1.FormattedValue"
            ] == "Ativo"
              ? "Aberta"
              : response.data[
                  "statecode@OData.Community.Display.V1.FormattedValue"
                ] == "Resolvido"
              ? "Encerrada"
              : "Cancelada",
        })
      })
      .catch((error) => {
        setDataLoadError(true)
      })
  }, [])

  useEffect(() => {
    const token = localStorage.getItem("token") || 0

    const api = axios.create({
      baseURL: process.env.REACT_APP_API_URL,
      headers: {
        Authorization: token,
      },
    })

    api
      .get("incident/" + incidentId + "/tasks")
      .then((response) => {
        if (response.data.length > 0) {
          const sortedData = response.data.sort((a, b) => {
            const dateA = new Date(a["scheduledstart"])
            const dateB = new Date(b["scheduledstart"])

            return dateB - dateA
          })

          setTasksData(sortedData)
        } else {
          setDataLoadError("No tasks")
        }
      })
      .catch((error) => {
        setDataLoadError(true)
      })
  }, [])

  return (
    <>
      <div id="content-wrapper">
        <div id="top-actions">
          <Link to={"/incident"}>
            <div className="action">
              <img
                src="/assets/icons/chevron.svg"
                alt=""
                className="icon chevron-left"
              />
              <span className="font text-2">Voltar</span>
            </div>
          </Link>
        </div>
        <div id="table-header">
          <div>
            <span className="text-4 font">
              <strong>Título da ocorrência: {incidentData.title}</strong>
            </span>
            <p>
              <span className="text-3 font">
                Descrição da ocorrência:{" "}
                <div
                  className="incident-desc text-1"
                  dangerouslySetInnerHTML={{
                    __html:
                      incidentData.description == undefined
                        ? ""
                        : incidentData.description.replaceAll("\n", "<br>"),
                  }}
                ></div>
              </span>
            </p>
          </div>
          <table className="incident-info">
            <tr>
              <td>
                <strong>Situação</strong>
              </td>
              <td>{incidentData["statusnewname"]}</td>
            </tr>
            <tr>
              <td>
                <strong>Criado em</strong>
              </td>
              <td>
                {
                  incidentData[
                    "createdon@OData.Community.Display.V1.FormattedValue"
                  ]
                }
              </td>
            </tr>
            <tr>
              <td>
                <strong>Solicitado por</strong>
              </td>
              <td>
                {
                  incidentData[
                    "_c2g_contact_value@OData.Community.Display.V1.FormattedValue"
                  ]
                }
              </td>
            </tr>
            <tr>
              <td>
                <strong>Contrato</strong>
              </td>
              <td>
                {
                  incidentData[
                    "_c2g_contrato_value@OData.Community.Display.V1.FormattedValue"
                  ]
                }
              </td>
            </tr>
            <tr>
              <td>
                <strong>Severidade</strong>
              </td>
              <td>
                {
                  incidentData[
                    "c2g_severidade@OData.Community.Display.V1.FormattedValue"
                  ]
                }
              </td>
            </tr>
            <tr>
              <td>
                <strong>Proprietário</strong>
              </td>
              <td>
                {
                  incidentData[
                    "_ownerid_value@OData.Community.Display.V1.FormattedValue"
                  ]
                }
              </td>
            </tr>
          </table>
        </div>
        <TasksTable data={tasksData} error={dataLoadError} />
      </div>
    </>
  )
}

export default Incident
